import { createFileRoute } from '@tanstack/react-router';
import { createServerFn } from '@tanstack/react-start';
import TermsAndConditions from '../pages/TermsAndConditions';
import { destinationMiddleware } from '../server/middleware/destinationMiddleware';
import { getLegal } from '../server/getLegal';
import { sanitizeHtml } from '../server/utlis/sanitizeHtml';

const loadDestination = createServerFn()
    .middleware([destinationMiddleware])
    .handler(async ({ context }) => {
        return context.destination;
    });

export const Route = createFileRoute('/terms')({
    beforeLoad: async () => {
        try {
            const destination = await loadDestination();
            return { destination };
        } catch (error) {
            console.error('Failed to load destination:', error);
            throw error;
        }
    },
    loader: async ({ context }) => {
        const { destination } = context;
        const legal = await getLegal().catch(() => ({}));
        const sanitized = legal?.termsAndConditions
            ? await sanitizeHtml({ data: { html: legal.termsAndConditions } })
            : '';
        // Quill serializes an "empty" editor as markup like "<p><br></p>" rather
        // than "" — that's truthy and would otherwise sneak past the check
        // above and render as a blank page instead of falling back.
        const hasVisibleText = sanitized.replace(/<[^>]+>/g, '').trim().length > 0;
        const termsHtml = hasVisibleText ? sanitized : '';
        return { destination, termsHtml };
    },
    // Server-rendered — see routes/index.jsx for why this replaces Helmet.
    head: ({ loaderData }) => {
        const siteUrl = (loaderData?.destination?.url || '').replace(/\/$/, '');
        return {
            meta: [
                { title: 'Wilderness Bookings | Terms' },
                ...(siteUrl ? [{ property: 'og:url', content: `${siteUrl}/terms` }] : []),
            ],
        };
    },
    component: TermsAndConditions,
    // ── Caching config 
    staleTime: 5 * 60 * 1000,   // reuse cached data for 5 mins on re-navigation
    gcTime: 10 * 60 * 1000,  // keep in memory for 10 mins after route unmounts
});